export default class SchuetzenfestzeltDashboardController {
    constructor(scope, Guestlists, PosService) {
        this.scope = scope;
        this.posService = PosService;
        this.guestlists = [];
        this.currentGuestlist = null;
        this.loading = true;
        this.displayType = 'checkin';
        this.checkedInRate = 0;
        this.store = Guestlists.reset({
            persists: false,
            listview: 'DashboardGuestlistListView'
        });
        this.store.commit('setFilters', []);
        this.init();
    }

    init() {
        this.updateGuestlists().then(() => {
            this.loading = false;
            this.apply();
        }, () => {
            this.apply();
        });
    }

    updateGuestlists() {
        this.guestlists = [
            {
                'id': null,
                'name': 'All Active Lists'
            }
        ];
        const colsToSelect = [
            'name',
            'date',
            'id',
            'confirmed_rsvps_count',
            'sum_pax_planned',
            'sum_pax_actual'
        ];


        return new Promise((resolve, reject) => {
            this.store.dispatch('getDefinitions').then(() => {
                let newColumns = [];
                _.forEach(this.store.getters.columns, function (curCol) {
                    curCol.visible = colsToSelect.indexOf(curCol.key) > -1;

                    newColumns.push(curCol);
                });
                this.store.commit('setColumns', newColumns);
                let sort = {
                    date: 'asc'
                };
                this.store.commit('setSort', sort);

                this.store.dispatch('getData').then(() => {
                    this.guestlists = this.guestlists.concat(this.store.state.data);
                    if (!this.currentGuestlist || this.guestlists.indexOf(this.currentGuestlist) === -1) {
                        this.selectGuestlist(this.guestlists[0]);
                    }
                    resolve(this.guestlists);
                }, (e) => {
                    reject(e);
                });
            }, (e) => {
                reject(e);
            });
        });
    }

    selectGuestlist(guestlist) {
        this.currentGuestlist = guestlist;
        const guestlistDate = new Date(this.currentGuestlist),
            currentDate = new Date();
        this.checkedInRate = 0;
        if (this.currentGuestlist.sum_pax_actual > 0) {
            this.checkedInRate = Math.ceil((this.currentGuestlist.sum_pax_actual / this.currentGuestlist.sum_pax_planned) * 100);
        }

        if (guestlistDate.getFullYear() < currentDate.getFullYear()
            || (
                (guestlistDate.getFullYear() === currentDate.getFullYear())
                && (guestlistDate.getMonth() < currentDate.getMonth())
            )
            || (
                (guestlistDate.getFullYear() === currentDate.getFullYear())
                && (guestlistDate.getMonth() === currentDate.getMonth())
                && (guestlistDate.getDay() <= currentDate.getDay())
            )
        ) {
            this.displayType = 'checkin';
        } else {
            this.displayType = 'default';
        }
        this.scope.$evalAsync();
    }

    openPOSModal() {
        this.posService.openPosModal();
    }

    apply() {
        this.scope.$evalAsync();
    }
}

SchuetzenfestzeltDashboardController.$inject = [
    '$scope',
    'Guestlists',
    'PosService'
];



// WEBPACK FOOTER //
// ./src/app/pages/dashboard/components/schuetzenfestzelt-dashboard/controller.js